// extracted by mini-css-extract-plugin
export default {"page":"oauth_page__74B3Q","loginfailed":"oauth_loginfailed__EsD5i","loginfaileddetail":"oauth_loginfaileddetail__jinoc","backBtn":"oauth_backBtn__vqKGq"};